<template>
  <div>
    <!-- 已经没有修改代采计划了 -->
    <div class="top">
      商家:
      <supply-select
        @change="
          (e) => {
            supply_id = e;
          }
        "
      ></supply-select>
      <el-button type="primary" @click="showDialog">查询</el-button>
      <div style="display: inline; margin-left: 20px">
        <el-upload
          ref="supplyfile"
          name="import_file"
          :action="action"
          :data="{ ptype: is_early_plan ? 11 : 2 }"
          style="display: inline"
          :auto-upload="true"
          :limit="1"
          :show-file-list="false"
          :on-success="uploadedSuccess"
          with-credentials
        >
          <el-button slot="trigger" type="warning">导入商品数据</el-button>
        </el-upload>
        <div v-if="is_early_plan" style="display: inline; margin-left: 10px">
          导入格式: A列=商家ID, B列=SKU编号, C列=计划数量,
          D列=入仓标签(赠品、特价、常规、商家自荐)
        </div>
        <div v-else style="display: inline; margin-left: 10px">
          导入格式: A列=商家ID, B列=SKU编号, C列=计划数量,
          D列=入仓标签(备货、赠品、特价、常规、买手小店),
          E列=代采类型（备货采购、当天备货）
        </div>
      </div>
    </div>
    <plan-goods-select
      ref="planGoodsSelect"
      :goods_label="options.goods_label"
      @submit="goodsSelected"
    ></plan-goods-select>
    <el-table
      :data="goods"
      border
      max-height="700px"
      style="margin-top: 20px"
      size="small"
    >
      <el-table-column
        label="序号"
        type="index"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="goods_name"
        label="商品名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="goods_label" label="入仓标签" align="center">
        <template #default="scope">
          <el-select v-model="scope.row.goods_label" size="small">
            <el-option
              v-for="item in options.goods_label"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="brand_name"
        label="品牌"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="goods_no"
        label="商品货号"
        align="center"
      ></el-table-column>
      <el-table-column prop="goods_img" label="图片" align="center">
        <template #default="scope">
          <div
            v-viewer
            style="
              width: 40px;
              height: 40px;
              overflow: hidden;
              cursor: pointer;
              display: inline-block;
            "
          >
            <img
              v-for="(item, key) in scope.row.middle_img"
              :key="key"
              :src="item"
              style="max-width: 100%; max-height: 100%"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="co_val" label="商品颜色" align="center">
      </el-table-column>
      <el-table-column prop="si_val" label="商品尺码" align="center">
      </el-table-column>
      <el-table-column
        prop="picker_group"
        label="商品数量"
        align="center"
        width="180px"
      >
        <template #default="scope">
          <el-input-number
            v-model="scope.row.plan_num"
            :min="1"
            size="small"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        prop="pg_name"
        label="代采组"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="plan_price"
        label="代采价"
        align="center"
      ></el-table-column>
      <el-table-column label="小计" align="center">
        <template #default="scope">
          <div>
            ￥{{
              (scope.row.plan_num * Number(scope.row.plan_price)).toFixed(2)
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button
            type="text"
            size="small"
            @click.native.prevent="removeRow(scope.$index)"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      style="
        text-align: right;
        height: 40px;
        background: #f3f3f3;
        line-height: 40px;
        padding: 0 40px;
        font-size: 14px;
        color: #ff4040;
      "
    >
      合计数量：{{ total.num }}件 合计金额： ¥{{ total.price }}
    </div>

    <div>
      <div class="card-title">备注信息</div>
      <el-input
        v-model.trim="textarea"
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
      ></el-input>
      <div style="text-align: right; margin-top: 20px">
        <el-button type="primary" size="small" @click="submit">提交</el-button>
        <el-button size="small" type="danger" @click="$router.go(-1)">
          取消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import supplySelect from "@/components/supplySelect.vue";
import planGoodsSelect from "@/components/PlanGoodsSelect.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    supplySelect,
    planGoodsSelect,
  },
  data() {
    const is_early_plan = !!this.$route.params.is_early_plan;
    const goods_label = [
      { value: "1", label: "备货" },
      { value: "2", label: "赠品" },
      { value: "3", label: "特价" },
      { value: "4", label: "常规" },
      { value: "7", label: "加流" },
    ];
    // 提前计划才有商家自荐的入仓标签
    if (is_early_plan) {
      goods_label.push({ value: "5", label: "商家自荐" });
    } else {
      // 手动计划才可以创建买手小店计划
      goods_label.push({ value: "6", label: "买手小店" });
    }

    return {
      supply_id: "",
      goods: [],
      textarea: "", // 备注内容
      options: {
        goods_label,
      },

      exists_sku: [], // 已存在的sku, 用于判断不要重复选择同sku的商品
      is_early_plan,
      action: `${apiBaseURL}/erp/WcgPlan/importPlanFile`,
    };
  },

  computed: {
    total() {
      let price = 0;
      let num = 0;
      this.goods.forEach((row) => {
        row.subtotal = row.plan_num * Number(row.plan_price);
        price += row.subtotal;
        num += row.plan_num;
      });
      price.toFixed(2);
      return { price, num };
    },
  },

  methods: {
    showDialog() {
      if (!this.supply_id) {
        return this.$message.e("请选择商家");
      }

      this.$refs.planGoodsSelect.calling(this.supply_id);
    },
    // 选中的商品
    goodsSelected(goods) {
      goods.forEach((row) => {
        // 列表上已经有sku了, 就不要重复添加了
        if (this.exists_sku.includes(row.sku)) {
          return;
        }
        this.goods.push(row);
        this.exists_sku.push(row.sku);
      });
    },
    // 移除一行
    removeRow(row_index) {
      this.goods.splice(row_index, 1);
      this.exists_sku.splice(row_index, 1);
    },

    // 提交计划
    submit() {
      if (this.goods.length == 0) return this.$message.e("没有商品数据");
      const param = {
        supply_id: this.supply_id,
        plan_type: 0, // 只能创建备货代采类型的了
        remarks: this.textarea,
        goods: JSON.parse(JSON.stringify(this.goods)), // 去掉深度赋值
        plan_id: 0, // 没有修改代采计划的功能了
        // is_early_plan: this.is_early_plan ? 1 : 0, // 提前代采计划
        // pgid ?
      };

      // 去掉没用的字段, 避免提交的数据又大又长
      param.goods.forEach((row) => {
        delete row.goods_img;
        delete row.main_img;
        delete row.middle_img;
        delete row.pg_name;
        delete row.goods_name;
        delete row.goods_kh;
        delete row.brand_name;
        delete row.sku_data;
      });

      // 又要转换成字符串
      param.goods = JSON.stringify(param.goods);

      // 提前代采计划的url不太一样
      let url = "/erp/wcgPlan/create";
      if (this.is_early_plan == 1) {
        url = "/erp/wcgPlan/createEarlyPlan";
      }
      this.$http.post(url, param).then((rs) => {
        if (rs.data.code != 200) {
          return this.$message.e(rs.data.msg);
        }
        this.$notify({
          title: "操作成功",
          message: "",
          type: "success",
        });
        this.$router.go(-1);
      });
    },

    // 上传文件成功
    uploadedSuccess(res) {
      if (res.code == 200) {
        if (res.data.result) {
          this.$message.success("导入成功");
        } else {
          this.$message.error(res.data.msg);
          if (typeof res.data.data.file !== undefined) {
            setTimeout(() => {
              this.$message.e("即将开始下载有错误的数据");
              window.open(apiBaseURL + res.data.data.file);
            }, 1000);
          }
        }
      } else {
        this.$message.e(res.msg);
      }
      this.$refs.supplyfile.clearFiles();
    },
  },
};
</script>

<style scoped>
.top {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wcgplan/EditPlan.vue